import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import Toast from './Toast';

function WelcomeToastBridge() {
  const location = useLocation();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');

  useEffect(() => {
    const welcomeMessage = location.state?.welcome;

    if (!welcomeMessage) {
      return;
    }

    setMessage(welcomeMessage);
    navigate(location.pathname, {replace: true});
  }, [location, navigate]);

  return (
    <Toast
      message={message}
      type="success"
      onClose={() => setMessage('')}
    />
  );
}

export default WelcomeToastBridge;